if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let containerType, autoplay;

      if (this.dataset.design) {
        this.design = this.dataset.design;
      }

      if (this.dataset.container) {
        containerType = this.dataset.container;
      }

      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === "true";
      }

      this.container = this.closest(".m-testimonials");
      this.total = parseInt(this.dataset.total || "0", 10);

      if (!this.design) {
        return console.warn("Failed to init Testimonials: design not found!!");
      }

      this.sliderContainer = this.querySelector(".swiper-container");

      if (!this.sliderContainer) {
        this.classList.add("opacity-100");
        return;
      }

      this.defaultSettings = {
        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: true,
        },
        navigation: {
          nextEl: this.container.querySelector(".m-slider-controls__button-next"),
          prevEl: this.container.querySelector(".m-slider-controls__button-prev"),
        },
        autoplay: autoplay
          ? {
              delay: 5000,
              pauseOnMouseEnter: false,
              disableOnInteraction: false,
            }
          : false,
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        speed: 500,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
      };

      this.settings = {};
      let gutter = 400;

      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,
            slideToClickedSlide: true,
            loop: true,
            loopAdditionalSlides: Math.max(this.total, 6),
            loopedSlides: Math.max(this.total, 6),
            normalizeSlideIndex: true,
            breakpoints: {
              768: {
                slidesPerView: Math.min(this.total || 3, 3),
                slidesPerGroup: 1,
                spaceBetween: 20,
                speed: 600,
              },
              1280: {
                slidesPerView: Math.min(this.total || 5, 5),
                slidesPerGroup: 1,
                spaceBetween: 30,
                speed: 600,
              },
            },
          };
          break;

        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            loopAdditionalSlides: Math.max(this.total, 3),
            loopedSlides: Math.max(this.total, 3),
            breakpoints: {
              768: {
                slidesPerView: Math.min(this.total || 3, 3),
                slidesPerGroup: 1,
              },
            },
          };
          break;

        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
            loopAdditionalSlides: Math.max(this.total, 3),
            loopedSlides: Math.max(this.total, 3),
            breakpoints: {
              768: {
                slidesPerView: Math.min(this.total || 3, containerType === "w-full" ? 3 : 2),
                slidesPerGroup: 1,
              },
            },
          };
          break;

        case "testimonials-4":
          if (containerType === "container-fluid") gutter = 200;
          if (containerType === "container") gutter = 150;

          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            slideToClickedSlide: true,
            loopAdditionalSlides: Math.max(this.total, 3),
            loopedSlides: Math.max(this.total, 3),
            breakpoints: {
              768: {
                spaceBetween: parseInt(gutter / 4),
                slidesPerView: Math.min(this.total || 3, 3),
                slidesPerGroup: 1,
              },
              992: {
                spaceBetween: gutter / 2,
                slidesPerView: Math.min(this.total || 3, 3),
                slidesPerGroup: 1,
              },
              1920: {
                spaceBetween: gutter,
                slidesPerView: Math.min(this.total || 3, 3),
                slidesPerGroup: 1,
              },
            },
          };
          break;

        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
            loopAdditionalSlides: Math.max(this.total, 4),
            loopedSlides: Math.max(this.total, 4),
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
            breakpoints: {
              768: {
                slidesPerView: Math.min(this.total || 2, 2),
                slidesPerGroup: 1,
              },
              1366: {
                slidesPerView: Math.min(this.total || 3, containerType === "container" ? 2 : 3),
                slidesPerGroup: 1,
              },
              1600: {
                slidesPerView: Math.min(this.total || 4, containerType === "container-fluid" ? 3 : 4),
                slidesPerGroup: 1,
              },
            },
          };
          break;

        case "testimonials-7":
          this.settings = {
            slidesPerView: "auto",
            slidesPerGroup: 1,
            spaceBetween: 16,
            loop: true,
            loopAdditionalSlides: Math.max(this.total, 4),
            loopedSlides: Math.max(this.total, 4),
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
            breakpoints: {
              768: {
                slidesPerView: Math.min(this.total || 2, 2),
                slidesPerGroup: 1,
                spaceBetween: 24,
              },
              1024: {
                slidesPerView: Math.min(this.total || 2, 2),
                slidesPerGroup: 1,
                spaceBetween: 30,
              },
            },
          };
          break;

        case "testimonials-8":
          this.settings = {
            fade: {
              crossFade: true,
            },
            pagination:
              this.dataset.paginationType == "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
          };
          break;

        case "testimonials-5":
          this.settings = {
            fade: {
              crossFade: true,
            },
          };
          break;
      }

      const images = this.querySelector(".m-tabs");

      if (images) {
        const interval = setInterval(() => {
          if (MinimogTheme.Tabs) {
            clearInterval(interval);
            this.imagesTab = new MinimogTheme.Tabs(images);
          }
        }, 50);
      }

      this.initSlider();
    }

    initSlider() {
      this.slider = new MinimogLibs.Swiper(this.sliderContainer, {
        ...this.defaultSettings,
        ...this.settings,
        on: {
          init: () => {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));

              if (this.slider && this.slider.update) {
                this.slider.update();
              }
            }, 100);
          },
          resize: () => {
            if (this.slider && this.slider.update) {
              this.slider.update();
            }
          },
        },
      });

      if (this.design === "testimonials-4") {
        this.slider.on("activeIndexChange", (swiper) => {
          const { realIndex } = swiper;
          this.querySelector(".m-testimonial-index").innerHTML = parseInt(realIndex) + 1;
        });
      }

      if (this.design === "testimonials-5" || this.design === "testimonials-8") {
        this.slider.on("slideChange", (swiper) => {
          const { realIndex } = swiper;

          if (this.imagesTab) {
            this.imagesTab.setActiveTab(realIndex);
          }
        });
      }

      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(ev) {
      const block = ev.target;
      const index = Number(block.dataset.index);

      if (this.slider) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}